<div class="modal-header">
  <h5 class="modal-title">{{ options.title }} </h5>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-3">
      <div class="errorpic"></div>
    </div>
    <div class="col-9">
      <p>
        An Error occurred during your Request:
      </p>
      <p>
        <b>
          You do not have permission to perform this request.
        </b>
      </p>
      <p *ngIf="options.message && options.message.length > 0">
        <b>
          <i>
            {{options.message}}
          </i>
        </b>
      </p>
      <hr>
      <h5>
        Technical Details
      </h5>
      <p *ngIf="options.statuscode">
        <b>
          Status Code:
        </b>
        <br>
        {{options.statuscode}}
      </p>
      <p *ngIf="options.statustext && options.statustext.length > 0">
        <b>
          Status Text:
        </b>
        <br>
        {{options.statustext}}
      </p>
      <p *ngIf="options.errorcode && options.errorcode.length > 0">
        <b>
          Error Code:
        </b>
        <br>
        {{options.errorcode}}
      </p>
      <p *ngIf="options.errorstring && options.errorstring.length > 0" class="break-all">
        <b>
          Error Identifier:
        </b>
        <br>
        {{options.errorstring}}
      </p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <sb-button classes="btn-primary" (click)="ok()">{{ 'lang.globals.ok' | translate }}
  </sb-button>
</div>
